export const getStoredSettings = (storageKey: string) => {
  try {
    const stored = localStorage.getItem(storageKey);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return null;
  }
};

export const saveSettings = (storageKey: string, filters: any, sort?: any) => {
  try {
    localStorage.setItem(storageKey, JSON.stringify({ filters, sort }));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};
